import { useEffect } from 'react';

export default function HomeSchema() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup';

    const websiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Superbuy Spreadsheet',
      url: siteUrl,
      description: 'The ultimate Superbuy Spreadsheet resource hub featuring organized product categories, shopping guides, and curated product finds.',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}search?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(websiteSchema);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}